/* eslint-disable complexity */
import { Functions } from "./functions";

export class Validador {
	static validarCnpj(cnpj: string): boolean {
		cnpj = cnpj.replace(/[^\d]+/g, "");

		if (cnpj === "") return false;

		if (cnpj.length !== 14) {
			return false;
		}

		if (
			cnpj === "00000000000000" ||
			cnpj === "11111111111111" ||
			cnpj === "22222222222222" ||
			cnpj === "33333333333333" ||
			cnpj === "44444444444444" ||
			cnpj === "55555555555555" ||
			cnpj === "66666666666666" ||
			cnpj === "77777777777777" ||
			cnpj === "88888888888888" ||
			cnpj === "99999999999999"
		) {
			return false;
		}

		let tamanho = cnpj.length - 2;
		let numeros = cnpj.substring(0, tamanho);
		const digitos = cnpj.substring(tamanho);
		let soma = 0;
		let pos = tamanho - 7;
		({ soma } = this.verificarSoma(tamanho, soma, numeros, pos));
		let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
		if (resultado !== parseInt(digitos.charAt(0))) {
			return false;
		}

		tamanho = tamanho + 1;
		numeros = cnpj.substring(0, tamanho);
		soma = 0;
		pos = tamanho - 7;
		({ soma } = this.verificarSoma(tamanho, soma, numeros, pos));
		resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
		if (resultado !== parseInt(digitos.charAt(1))) {
			return false;
		}

		return true;
	}

	static validarCpf(cpf: string): boolean {
		cpf = cpf.replace(/[^\d]+/g, "");
		if (cpf == null) {
			return false;
		}
		if (cpf.length !== 11) {
			return false;
		}
		if (
			cpf === "00000000000" ||
			cpf === "11111111111" ||
			cpf === "22222222222" ||
			cpf === "33333333333" ||
			cpf === "44444444444" ||
			cpf === "55555555555" ||
			cpf === "66666666666" ||
			cpf === "77777777777" ||
			cpf === "88888888888" ||
			cpf === "99999999999"
		) {
			return false;
		}
		let numero = 0;
		let caracter = "";
		const numeros = "0123456789";
		let j = 10;
		let somatorio = 0;
		let resto = 0;
		let digito1 = 0;
		let digito2 = 0;
		let cpfAux = "";
		cpfAux = cpf.substring(0, 9);
		for (let i = 0; i < 9; i++) {
			caracter = cpfAux.charAt(i);
			if (numeros.search(caracter) === -1) {
				return false;
			}
			numero = Number(caracter);
			somatorio = somatorio + numero * j;
			j--;
		}
		resto = somatorio % 11;
		digito1 = 11 - resto;
		if (digito1 > 9) {
			digito1 = 0;
		}
		j = 11;
		somatorio = 0;
		cpfAux = cpfAux + digito1;
		for (let i = 0; i < 10; i++) {
			caracter = cpfAux.charAt(i);
			numero = Number(caracter);
			somatorio = somatorio + numero * j;
			j--;
		}
		resto = somatorio % 11;
		digito2 = 11 - resto;
		if (digito2 > 9) {
			digito2 = 0;
		}
		cpfAux = cpfAux + digito2;
		return cpf !== cpfAux;
	}

	static validarCpfCnpj(valor: string): boolean {
		valor = Functions.removeMask(valor);
		if (valor.length <= 11) {
			valor = Functions.zeroLeft(valor, 11);
			return this.validarCpf(valor);
		} else {
			valor = Functions.zeroLeft(valor, 14);
			return this.validarCnpj(valor);
		}
	}
	static verificarSoma(tamanho: number, soma: number, numeros: string, pos: number) {
		for (let i = tamanho; i >= 1; i--) {
			soma += parseInt(numeros.charAt(tamanho - i)) * pos;
			pos--;
			if (pos < 2) {
				pos = 9;
			}
		}
		return { soma, pos };
	}

	static IsEmail(email: string): boolean {
		return /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi.test(email);
	}
}

export function isAvaliacaoImovelRural(siglaTipoCaracteristica: string): boolean {
	return siglaTipoCaracteristica === "AR1" || siglaTipoCaracteristica === "AR2" || siglaTipoCaracteristica === "AR3";
}

export function isAvaliacaoImovelUrbano(siglaTipoCaracteristica: string): boolean {
	return siglaTipoCaracteristica === "AU1" || siglaTipoCaracteristica === "AU2" || siglaTipoCaracteristica === "AU3";
}

export function isVistoriaDesembolsoRural(siglaTipoCaracteristica: string): boolean {
	return siglaTipoCaracteristica === "VDR";
}

export function isVistoriaDesembolsoUrbano(siglaTipoCaracteristica: string): boolean {
	return siglaTipoCaracteristica === "VDU";
}

export function isCriticaDeOrcamento(siglaTipoCaracteristica: string): boolean {
	return siglaTipoCaracteristica === "COU";
}

export function isParecerTecnicoRural(siglaTipoCaracteristica: string): boolean {
	return siglaTipoCaracteristica === "PTR";
}
